import { Grid } from '@material-ui/core';
import React from 'react';
import { ThemeProvider } from '../../../../theme-config/ThemeProvider';
import InfoTile from './InfoTile';
import styles from './style';

/**
 * @name InfoTileContainer
 * @param {*} props - Strapi Data
 * @returns {JSX.Element} - Renders InfoTile component
 */
const InfoTileContainer = props => {
    const classes = styles();
    return (
        <ThemeProvider palette={props?.cmsData?.Info_Tile_Theme?.theme}>
            <Grid container className={classes.infoMainContainer}>
                <InfoTile cmsData={props?.cmsData} handleAction={props?.handleAction} />
            </Grid>
        </ThemeProvider>
    );
};
InfoTileContainer.displayName = 'InfoTileContainer';
export default InfoTileContainer;
